import App from "next/app";
import React from "react";

// Suppress known benign Fela className hydration mismatch.
// Root cause: fela-plugin-prefixer uses browser UA detection so Node.js and
// Chrome emit different vendor-prefixed property names for the same declaration.
// CSS output is equivalent on both sides — purely a cosmetic console warning.
// Documented in project checklist as a known low-priority item.
if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
    const _consoleError = console.error.bind(console);
    console.error = (...args) => {
        if (typeof args[0] === "string" && args[0].includes("className") && args[0].includes("did not match")) return;
        _consoleError(...args);
    };
}
import FelaProvider from "~/components/fela-provider";
import get from "lodash.get";
import { getColorSet } from "~/modules/colors";

// Components
import Main from "~/layouts/main";
import { ThemeContext } from "~/context/theme";

// Global site styles
//import "~/assets/styles/index.styl";
import "~/assets/styles/index.css";
import "~/assets/styles/loader.css";

// Boot up route loading indicator
import "~/components/global/loader";

// Register client side redirect checks
import "~/modules/client-redirects";

import { DataContext } from "~/context/content";

class MyApp extends App {
    static async getInitialProps({ Component, ctx }) {
        let pageProps = {};

        if (Component.getInitialProps) {
            pageProps = await Component.getInitialProps(ctx);
        }

        return {
            pageProps
        };
    }

    render() {
        let { Component, pageProps, renderer, router } = this.props;

        const data = pageProps ? pageProps.data : {};

        const pageData = get(data, "listing_page", data);

        const pageColors = getColorSet(
            get(pageData, "acf.theme_primary_color", "sky")
        );

        return (
            <FelaProvider renderer={renderer}>
                <DataContext.Provider value={data}>
                    <ThemeContext.Provider value={pageColors}>
                        <Main className={"main"}>
                            <Component
                                {...pageProps}
                                key={
                                    typeof location !== "undefined"
                                        ? location.pathname
                                        : router.route
                                }
                            />
                        </Main>
                    </ThemeContext.Provider>
                </DataContext.Provider>
            </FelaProvider>
        );
    }
}

export default MyApp;
